import { useThorData, 
// eslint-disable-next-line no-restricted-imports
useThorView, } from "@aviv-dxp/react-thor";
import { useEffect } from "react";
import { IS_SERVER } from "@/constants";
import { useClassified } from "@/contexts/classified";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";
import { useAuthenticationTracking } from "@/hooks/tracking/useAuthenticationTracking";
/**
 * @remarks: as of Dec. 2024, the Legacy Tracking is used on French brands to feed the Harvest Workflow (Consummer Stats, Recommendation API)
 * It is based on the Thor Library / GTM to ingest GA3-formatted data
 * It should be replaced at some point by WL Backend Tracking https://avivgroup.atlassian.net/browse/SEEKERWL-1379
 *
 * See customerActions for the similar legacy solution for German brands
 */
export const useTrackingLegacyView = () => {
    var _a;
    const legacyTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking;
    const hasLegacyTrackingData = !!legacyTrackingData;
    const { state } = useAuthentication();
    const { authTrackingLegacyData } = useAuthenticationTracking();
    const isPreviewMode = useIsPreviewMode();
    const clientSideData = () => {
        if (IS_SERVER)
            return {};
        // eslint-disable-next-line no-restricted-globals
        const { referrer, location } = window.document;
        return {
            url_path: location.pathname,
            referrer,
        };
    };
    const viewProps = Object.assign(Object.assign({}, legacyTrackingData), clientSideData());
    const LegacyView = useThorView({
        viewProps,
        compatibilities: { GA4: false, GA3: true },
    });
    const LegacyUser = useThorData({ data: { user: authTrackingLegacyData } });
    // ThorEvent object is subject to change (so it's not listed as dep)
    useEffect(() => {
        if (state !== "pending" && !isPreviewMode && hasLegacyTrackingData) {
            setTimeout(() => {
                LegacyView();
                LegacyUser();
            }, 10);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, isPreviewMode, hasLegacyTrackingData]);
};
